'use client';

import { ErrorBoundary } from 'react-error-boundary';

export default ErrorBoundary;
